import { definePanel } from '@/app/definePanel';
import { RulesIcon } from '@/components/occurra/icons/RulesIcon';

export default definePanel({
    id: 'rules',
    title: 'Rules',
    description: 'What the agents watch for, and what happens when they find it.',
    icon: RulesIcon,
    // Combined list + editor. Its pixel range keeps the editor useful while
    // internal container queries collapse the rail and stack When/Do.
    width: { min: 800, default: 800, max: Infinity, fill: false },
    modes: ['settings'],
    themes: 'any',
    order: 3.6,
    // The combined panel owns its own rail/editor header and footer chrome.
    isHeaderless: true,
    // ruleId lives in this panel's local props in localStorage (not URL-synced).
    urlSyncedProps: [],
});
